import React from "react";

import { NodeType } from "src/gen/schema/models/fabric";
import { osTypeToJSON } from "src/gen/schema/models/global";
import { Node } from "src/gen/schema/models/models";
import { NodeConfig } from "src/gen/schema/schema/schema";
import { titleCase } from "src/utils/string";

type NodeProps = {
  node: Node | NodeConfig;
};

// Insert into default case to make sure all cases are always covered
export function unreachable(x: never): void {
  throw new Error(`This should be unreachable! but got ${x}`);
}

export const isNodeBound = (chassis: Node): boolean => {
  return chassis.nodeType !== NodeType.NODE_BLUEPRINT;
};

export const hasAnyUnBoundNode = (nodes: Node[]): boolean => {
  return nodes.some((c) => c.nodeType === NodeType.NODE_BLUEPRINT);
};

export function getNodeById(nodes: Node[], id: string): Node | undefined {
  return nodes.find((item): boolean => {
    return item.id === id;
  });
}

export const NodeOSTypeString = ({ node }: NodeProps): React.ReactNode => {
  return titleCase(osTypeToJSON(node.osType));
};
